import React, { Component } from 'react'
import JewelryPanel from '../jewelry-panel'
import SelectItem from '../../select-item'
import Spacer from '../../spacer'
import {
  showPendantChainPanel
} from '../../../utils/jewelry-validation'

class PendantChainPanel extends Component {
  render () {
    const props = this.props
    return (
      <JewelryPanel
        id='pendantChainPanelContainer'
        show={showPendantChainPanel(props)}
        isResetting={props.isResetting}>

        <Spacer lg />

        <SelectItem
          label='Chain?'
          labelId='hasPendantChain'
          options={[
            {value: false, label: 'No'},
            {value: true, label: 'Yes'}
          ]}
          value={props.has_pendant_chain}
          onChange={props.onChangeVal.bind(this, 'has_pendant_chain')}
          initVal={null}
        />

        <JewelryPanel
          id='pendantChainPanel'
          show={props.has_pendant_chain}
          isResetting={props.isResetting}>

          <Spacer xxs />

          <SelectItem
            id='pendant_chain_length'
            label='Chain Length'
            labelId='pendantChainLength'
            options={[
              {value: 'inches_16', label: '16 Inches'},
              {value: 'inches_18', label: '18 Inches'},
              {value: 'inches_20', label: '20 Inches'}
            ]}
            value={props.pendant_chain_length}
            onChange={props.onChangeVal.bind(this, 'pendant_chain_length')}
            initVal={null}
          />

          <Spacer xxs />

          <SelectItem
            id='pendant_chain_width'
            label='Chain Weight'
            labelId='pendantChainWidth'
            options={[
              {value: 'light', label: 'Light'},
              {value: 'medium', label: 'Medium'},
              {value: 'heavy', label: 'Heavy'}
            ]}
            value={props.pendant_chain_width}
            onChange={props.onChangeVal.bind(this, 'pendant_chain_width')}
            initVal={null}
          />

          <Spacer xxs />

          <SelectItem
            id='pendant_chain_metal_type'
            label='Chain Primary Metal'
            labelId='pendantChainMetalType'
            options={[
              {value: 'white_gold_14k', label: '14k White Gold'},
              {value: 'white_gold_18k', label: '18k White Gold'},
              {value: 'yellow_gold_14k', label: '14k Yellow Gold'},
              {value: 'yellow_gold_18k', label: '18k Yellow Gold'},
              {value: 'rose_gold_14k', label: '14k Rose Gold'},
              {value: 'platinum', label: 'Platinum'}
            ]}
            value={props.pendant_chain_metal_type}
            onChange={props.onChangeVal.bind(this, 'pendant_chain_metal_type')}
            initVal={null}
          />
        </JewelryPanel>
      </JewelryPanel>
    )
  }
}

export default PendantChainPanel



// WEBPACK FOOTER //
// ./src/components/jewelry-search-filters/pendant-chain-panel/index.js